import * as angular from "angular";
import contactInfo from "./contact-info";
import contactInfoModal from "./contact-info-modal";

export default angular
	.module("vesl.components.contact-info", [
		contactInfo,
		contactInfoModal
	])
	.name;
